export const SUBTITLE_CONTENT =
  'Mit unserer Online-Immobilienbewertung erhalten Sie schnell und unkompliziert einen realistischen (Ver-) Kaufspreis Ihrer Immobilie.';
export const TITLE = 'Mein Immobilienpreis';
